<template>
     <div class="imagedrop">
         <drop @drop="storeImage(...arguments)" class="dropTarget">
             <img id="thumb1" :src="imgSrc" v-if="imgSrc" class="smallImg"/>
             <center v-if="!imgSrc" class="dropText">{{dropText}}</center>
         </drop>
         <div class="error--text" v-if="errMessage">
           {{errMessage}}
         </div>
     </div>

</template>

<script>
/* This file is a drop target for a single image. Use it like this:

<ImageDrop @uploadComplete="uploadComplete" @removeComplete="imageRemoved"></ImageDrop>

*/
import {Drag, Drop} from 'vue-drag-drop'
import Vue from 'vue'
import config from '../../config.js'
import utils from '../../utils.ts'

Vue.component('drag', Drag)
Vue.component('drop', Drop)

export default {
  name: 'ImageDrop',
  components: {
  },
  props: ['src'], // src can be a dataURL or URL
  data () {
    return {
      imageType: null,
      imgBlob: null, // This is to show the local information
      file: null,
      dropText: 'Drop image here',
      errMessage: null,
      uploading: false,
      progressPercentage: 0
    }
  },
  // watch: {
  //   currentPic: function (val) {
  //     console.log('CURRENT PIC IS CHANGED: ' + val)
  //     if (val) {
  //       this.convertImgToDataURL(val.downloadURL)
  //     }
  //   }
  // },
  computed: {
    imgSrc: function () {
      console.log('Typeof ImgSrc: ' + typeof (this.src))
      if (this.src instanceof Blob) {
        console.log('Hopuston we have a BLOB! ImageDrop')
        var urlCreator = window.URL || window.webkitURL
        var imageUrl = urlCreator.createObjectURL(this.src) // So we can view it
        // TODO:  Make sure to delete this imageURL from memory!
        return imageUrl
      } else {
        return this.src
      }
    }

  },
  methods: {
    storeImage: function (transferData, nativeEvent) {
      this.errMessage = null
      this.handleFiles(nativeEvent.dataTransfer.files)
    },
    scaleImg: function (imgBlob, fileName, fileType, maxDimension) {
      // Scale the image and keep the aspect ratio
      // maxDimension will be the biggest it can be on either length or width
      //
      // This will also automatically remove the EXIF data.
      // Return a Promise

      console.log('Scale IMG 1')
      let newWidth
      let newHeight
      const reader = new FileReader()
      const p = new Promise((resolve, reject) => {
        reader.onload = event => {
          const img = new Image()

          img.src = event.target.result
          img.onload = () => {
            if (img.width > maxDimension || img.height > maxDimension) {
              // We need to scale the image
              if (img.width > img.height) {
                newWidth = maxDimension
                newHeight = img.height * (maxDimension / img.width)
              } else {
                newHeight = maxDimension
                newWidth = img.width * (maxDimension / img.height)
              }
            } else {
              newWidth = img.width
              newHeight = img.height
            }
            console.log('Scaled img: ' + newWidth + '  ' + newHeight)

            const elem = document.createElement('canvas')
            elem.width = newWidth
            elem.height = newHeight
            const ctx = elem.getContext('2d')
            // img.width and img.height will give the original dimensions
            ctx.drawImage(img, 0, 0, newWidth, newHeight)

            // Polyfill toBlob support onto canvas if it's needed.
            // See: https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob
            utils.addToBlobSupportIfNeeded()

            // toBlob is supported --- yay!
            ctx.canvas.toBlob((blob) => {
              // const file = new File([blob], fileName, {
              //   type: fileType,
              //   lastModified: Date.now()
              // })

              blob.lastModifiedDate = new Date()
              blob.fileName = fileName
              console.log('Scale Img completed...' + blob)
              // resolve(file)
              resolve(blob)
              // resolve(imgBlob)
            }, fileType, 0.9)
          }
        } // End of reader.onload
        reader.onerror = error => {
          console.log(error)
          reject(error)
        }

        reader.readAsDataURL(imgBlob)
      })
      return p
    },
    // convertImgToDataURL: function (url) {
    //   var image = new Image()
    //
    //   image.onload = function () {
    //     var canvas = document.createElement('canvas')
    //     canvas.width = this.naturalWidth - 1 // or 'width' if you want a special/scaled size
    //     canvas.height = this.naturalHeight - 1 // or 'height' if you want a special/scaled size
    //
    //     canvas.getContext('2d').drawImage(this, 0, 0)
    //
    //     // Get raw image data
    //     // callback(canvas.toDataURL('image/png').replace(/^data:image\/(png|jpg);base64,/, ''))
    //
    //     // ... or get as Data URI
    //     this.dataURL = canvas.toDataURL('image/png')
    //   }
    //
    //   image.src = url
    // },
    // read & create an image from the image file
    handleFiles: function (files) {
      this.errMessage = null
      if (files.length !== 1) {
        // Show an error, we can only drop one!
        this.errMessage = 'You can only drop a single file here!'
        return
      }
      this.file = files[0]
      this.imageType = /image.*/
      if (!this.file.type.match(this.imageType)) {
        this.errMessage = 'File is not an image.'
        return
      }

      if (this.file.size > config.maxFileSize) {
        const inMB = Math.floor(config.maxFileSize / 1e6)
        this.errMessage = 'Image is too large. Max image size is ' + inMB + ' MB'
        return
      }

      const maxDimension = 1500
      this.scaleImg(this.file, this.file.name, this.file.type, maxDimension).then((scaledFile) => {
        this.$emit('newFile', {'imgBlob': scaledFile, 'fileName': this.file.name})

        // if (scaledFile.type === 'image/jpeg') {
        //   // We have to remove EXIF
        //   var fr = new FileReader()
        //   fr.onload = this.removeExif // onload fires after reading is complete
        //   fr.readAsArrayBuffer(scaledFile) // begin reading
        // } else {
        //   // File is already a blob so just emit it.
        //   this.$emit('newFile', {'imgBlob': scaledFile, 'fileName': scaledFile.name})
        // }
      })
    }, // end handleFiles
    'removeExif': function (event) {
      console.log('removeing Exif')
      // Remove the exif data
      const result = event.target.result
      var dv = new DataView(result)
      var offset = 0
      var recess = 0
      var pieces = []
      let newBlob = null
      var i = 0
      // Code from: http://jsfiddle.net/mowglisanu/frhwm2xe/3/
      if (dv.getUint16(offset) === 0xffd8) {
        offset += 2
        var app1 = dv.getUint16(offset)
        offset += 2
        while (offset < dv.byteLength) {
          if (app1 === 0xffe1) {
            pieces[i] = {recess: recess, offset: offset - 2}
            recess = offset + dv.getUint16(offset)
            i++
          } else if (app1 === 0xffda) {
            break
          }
          offset += dv.getUint16(offset)
          app1 = dv.getUint16(offset)
          offset += 2
        }
        if (pieces.length > 0) {
          var newPieces = []
          pieces.forEach(function (v) {
            newPieces.push(result.slice(v.recess, v.offset))
          }, this)
          newPieces.push(result.slice(recess))
          newBlob = new Blob(newPieces, {type: 'image/jpeg'})
        } else {
          console.log('No exif info')
          newBlob = this.file
        }
      }

      // emit the file
      this.$emit('newFile', {'imgBlob': newBlob, 'fileName': this.file.name})
    }
    // 'createImage': function (event) {
    //   // This is the callback after the img has been loaded into memory
    //   // Always returns to actual image as a Data URL.
    //   const imgBlob = event.target.result
    //   // const dataURL = event.target.result
    //   // this.dataURL = dataURL
    //   this.imgBlob = imgBlob
    //   this.$emit('newFile', {'imgBlob': this.imgBlob, 'fileName': this.file.name})
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.imagedrop {
    width:100%;
    background-color: white;
    margin:5px;

}
.dropTarget {
    border-style: dotted;
    min-height:100px;
    height:100%;
}

.dropText {
  line-height: 100px;
}
.smallImg {
    width:100%;
}

</style>
